import React, { useState, useContext, useEffect, useRef } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./i18n";
import SharedStateContext from "./context/sharedstate";
import { AuthContext } from "./context/AuthContext";

        // // Die volgende blok kry die groep van die versoeker:
        // const token = localStorage.getItem("accessToken");
        // const response = await fetch(baseUrl + "v1/gebruiker/", {
        //   method: "GET",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `Bearer ${token}`,
        //   },
        // });         
        // const rouResponse = await response.text();
        // const userdata = JSON.parse(rouResponse);
        // const gebruikerGroep = userdata[0].groups[0] ?  userdata[0].groups[0] : "None";
        // console.log("Gebruikergroep",gebruikerGroep)
        // // Tot hier die blok.

const Navbar = ({ isLoggedIn, onLogout }) => {
  const { auth } = useContext(AuthContext);

  // State to manage the navbar's visibility
  const [nav, setNav] = useState(false);

  // Toggle function to handle the navbar's display
  const handleNav = () => {
    setNav(!nav);
  };

  // Claude: bugfix reported during UAT — flex-wrapping the bar (see the previous fix, now
  // Claude: replaced by this one) fit everything but looked visually broken ("aesthetically
  // Claude: unsound"). Per instruction, the 5 workflow items (Requested Terms through Duplicate
  // Claude: Cleanup) are now grouped behind a single "Actions" button that opens a slide-in
  // Claude: drawer, modelled on the existing mobile nav's own slide-in panel below for a
  // Claude: consistent interaction pattern rather than introducing a new one.
  const [actionsOpen, setActionsOpen] = useState(false);
  const toggleActions = () => setActionsOpen(!actionsOpen);
  const actionsRef = useRef(null);

  // Claude: "changing 'About us' to a dropdown that includes 'Contact us' and the user manual" —
  // requested directly. Same dropdown mechanism as the "Actions" button above, just for these
  // three informational pages instead of the workflow items.
  const [aboutOpen, setAboutOpen] = useState(false);
  const toggleAbout = () => setAboutOpen(!aboutOpen);
  const aboutRef = useRef(null);

  // Claude: bugfix reported directly — "the Actions menu backdrop intercepts clicks, so underlying
  // Claude: links sometimes cannot be chosen." The previous approach (an invisible, fixed inset-0
  // Claude: div under the dropdown) swallowed the FIRST click on anything else on the page while a
  // Claude: dropdown was open — including other nav links — since that div sat above them and had
  // Claude: no visual indication it was there. A document-level "was this click outside the
  // Claude: dropdown" listener closes the dropdown without intercepting the click itself, so a
  // Claude: click on another link both closes the dropdown and reaches that link, matching the
  // Claude: standard click-outside pattern (Bootstrap/Radix/Headless UI etc. all do this rather
  // Claude: than an overlay) instead of the mobile menu's own deliberately-dimming backdrop, which
  // Claude: is a different, full-height slide-in panel and keeps its overlay.
  useEffect(() => {
    function handleClickOutside(event) {
      if (actionsOpen && actionsRef.current && !actionsRef.current.contains(event.target)) {
        setActionsOpen(false);
      }
      if (aboutOpen && aboutRef.current && !aboutRef.current.contains(event.target)) {
        setAboutOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [actionsOpen, aboutOpen]);

  const { t, i18n } = useTranslation();
  const { interfaceLanguage, setInterfaceLanguage } =
    useContext(SharedStateContext);

  // Claude: bugfix reported directly — "About us, Add term, Search, Actions, Login, etc. do not
  // Claude: always appear exactly aligned... About us is a few pixels too high." The About/Actions
  // Claude: buttons put all their padding on the clickable element itself, but the Add
  // Claude: term/Search/Login/Logout links had padding on BOTH the <li> (p-2) AND the link itself
  // Claude: (px-1 pt-1, applied asymmetrically — top only) — a different, taller box model that
  // Claude: shifted their text relative to the button-based items. One shared class for every
  // Claude: top-level desktop nav item's clickable element (used below on the About/Actions
  // Claude: buttons and the Add term/Search/Login/Logout links alike) guarantees they can't drift
  // Claude: apart again.
  const NAV_ITEM_CLASS =
    "text-gray-800 bg-white p-2 hover:bg-gray-100 rounded-md cursor-pointer duration-300 hover:text-black text-sm font-medium inline-flex items-center";

  // Claude: grouped behind the "About us" dropdown (see aboutOpen above) instead of being
  // individual top-level nav items — User manual is new; About us/Contact us moved in here.
  const aboutItems = [
    {
      id: 14,
      text: (
        <Link
          to="/about"
          className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
          onClick={() => setAboutOpen(false)}
        >
          {t("about")}
        </Link>
      ),
    },
    {
      id: 15,
      text: (
        <Link
          to="/contact"
          className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
          onClick={() => setAboutOpen(false)}
        >
          {t("contact")}
        </Link>
      ),
    },
    {
      id: 16,
      text: (
        <Link
          to="/user-manual"
          className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
          onClick={() => setAboutOpen(false)}
        >
          {t("user_manual")}
        </Link>
      ),
    },
  ];

  // Array containing navigation items
  const navItems = [
    {
      id: 3,
      text:
        auth.userName != null ? (
        <Link
          to="/addword"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("addterm")}{" "}
        </Link>
      ) : ("not allowed"),
    },
    {
      id: 4,
      text:
        localStorage.getItem("bladsy") === "LandingPage" ?
      (
        <Link
          to="/advanced"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("advanced")}{" "}
        </Link>
      ) : (
        <Link
          to="/"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("search")}{" "}
        </Link>
      ),
    },
  ];

  // Claude: the workflow/admin items grouped into the "Actions" drawer (see actionsOpen above) —
  // Requested Terms through Duplicate Cleanup, same role gating as before, just no longer rendered
  // as individual top-level nav items.
  const actionItems = [
    {
      id: 5,
      // Claude: bugfix reported directly — "'Requested terms' should be available for all
      // Claude: registered users," not administrator-only. Matches the relaxed redirect in
      // Claude: ListRequests.js and the "My suggestions" item below (auth.userName != null).
      text:
        auth.userName != null ? (
          <Link
            to="/requestedterms"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("requestlist")}
          </Link>
        ) : (null
        ),
    },
    {
      id: 7,
      // Claude: was approver/administrator only. UAT feedback — "Flagged should be available only
      // Claude: to administrators, approvers and editors" — editors can now flag a pending word
      // Claude: from this queue (see review_word in views.py), so they need to be able to reach
      // Claude: it; ReviewQueue.js itself only offers them the Flag decision, not Approve/Reject.
      text:
        auth.userRole === "editor" || auth.userRole === "approver" || auth.userRole === "administrator" ? (
          <Link
            to="/review-queue"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("review_queue")}
          </Link>
        ) : (null),
    },
    {
      id: 8,
      text:
        auth.userName != null ? (
          <Link
            to="/my-suggestions"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("my_suggestions")}
          </Link>
        ) : (null),
    },
    {
      id: 9,
      text:
        auth.userRole === "editor" || auth.userRole === "approver" || auth.userRole === "administrator" ? (
          <Link
            to="/missing-terms"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("missing_terms")}
          </Link>
        ) : (null),
    },
    {
      id: 10,
      text:
        auth.userRole === "approver" || auth.userRole === "administrator" ? (
          <Link
            to="/duplicate-cleanup"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("duplicate_cleanup")}
          </Link>
        ) : (null),
    },
    {
      id: 11,
      text:
        auth.userRole === "administrator" ? (
          <Link
            to="/user-admin"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("user_admin")}
          </Link>
        ) : (null),
    },
    {
      id: 12,
      text:
        auth.userRole === "administrator" ? (
          <Link
            to="/term-admin"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("term_admin")}
          </Link>
        ) : (null),
    },
    {
      id: 13,
      // Claude: alpha-tester feedback — "add a password reset function for logged in users." Any
      // Claude: logged-in user should be able to reach this, same gating as My suggestions above.
      text:
        auth.userName != null ? (
          <Link
            to="/change-password"
            className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md"
            onClick={() => setActionsOpen(false)}
          >
            {t("change_password")}
          </Link>
        ) : (null),
    },
  ];
  const visibleActionItems = actionItems.filter((item) => item.text !== null);

  const authItem = {
    id: 6,
    text:
      auth.userName === null ? (
        <Link
          to="/login"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("login")}{" "}
        </Link>
      ) : (
        <Link
          to="/logout"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("logout")}{" "}
        </Link>
      ),
  };

  return (
    <div className="bg-white shadow-lg flex flex-wrap justify-between items-center max-w-7xl mx-auto px-3 py-2">
      {/* Logo */}

      {/* Desktop Navigation */}
      <ul data-testid="desktop-nav" className="hidden lg:flex items-center">
        {/* Claude: "changing 'About us' to a dropdown that includes 'Contact us' and the user
            manual" — requested directly. Same anchored-dropdown pattern as the "Actions" button
            below. */}
        <li className="relative m-2" ref={aboutRef}>
          <button
            onClick={toggleAbout}
            className={NAV_ITEM_CLASS}
          >
            {t("about")}
            <span className="ml-1">▾</span>
          </button>
          {aboutOpen && (
            <div
              data-testid="about-drawer"
              className="absolute left-0 top-full mt-1 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50 py-1"
            >
              <ul>
                {aboutItems.map((item) => (
                  <li key={item.id}>{item.text}</li>
                ))}
              </ul>
            </div>
          )}
        </li>
        {navItems.map((item) => (
          <li
            key={item.id}
            className="m-2"
          >
            {item.text}
          </li>
        ))}
        {/* Claude: the "Actions" button + dropdown replacing the 5 individual workflow nav items
            (see actionItems/visibleActionItems above) — only rendered if the current role can see
            at least one of them (matches how each item hid itself individually before). Anchored
            below the button (relative/absolute, not a fixed full-height side panel) and styled to
            match the rest of the bar's items (rounded-md/shadow/hover states) per feedback that
            the previous slide-in-drawer version appeared in the wrong place and looked out of
            place stylistically. */}
        {visibleActionItems.length > 0 && (
          <li className="relative m-2" ref={actionsRef}>
            <button
              onClick={toggleActions}
              className={NAV_ITEM_CLASS}
            >
              {t("actions")}
              <span className="ml-1">▾</span>
            </button>
            {actionsOpen && (
              <div
                data-testid="actions-drawer"
                className="absolute right-0 top-full mt-1 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50 py-1"
              >
                <ul>
                  {visibleActionItems.map((item) => (
                    <li key={item.id}>{item.text}</li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        )}
        <li className="m-2">
          {authItem.text}
        </li>
      </ul>

      {/* Mobile Navigation Icon */}
      <div onClick={handleNav} className="block lg:hidden">
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>

      {/* Mobile Navigation Menu */}
      <ul
        className={
          nav
            ? "fixed lg:hidden left-0 top-0 w-[40%]  mt-12 bg-white ease-in-out duration-200 lg:space-y-0  space-y-2 overflow-auto"
            : "ease-in-out w-[60%] duration-2 fixed top-0 bottom-12 left-[-100%]"
        }
      >
        {/* Mobile Logo */}

        {/* Mobile Navigation Items — the drawer above is a desktop-only affordance (the mobile
            menu is already its own vertical slide-in panel, so the workflow items are just listed
            inline here rather than nesting a second drawer inside it). */}
        {[...aboutItems, ...navItems, ...visibleActionItems, authItem].map((item) => (
          <li
            key={item.id}
            className="bg-gray-100 text-gray-800 p-2 rounded-md hover:bg-white-200 shadow-lg duration-300 hover:text-black cursor-pointer border-gray-600"
          >
            {item.text}
          </li>
        ))}
      </ul>
      {/* Claude: alpha-tester feedback — "Clicking your username logs you out instead of opening a
          profile page." This was a link to /logout; there is no profile page, so the username is
          now plain text showing who is logged in. Logging out stays on the explicit "Log out"
          nav item. */}
      <span
        data-testid="nav-username"
        className="inline-flex items-center px-1 pt-1 text-sm font-medium text-red-900"
      >
        {" "}
        {auth.userName}
        {" "}
      </span>

      <select
        value={interfaceLanguage}
        onChange={(e) => {
          setInterfaceLanguage(e.target.value);
          i18n.changeLanguage(e.target.value);
          localStorage.setItem("taal", e.target.value);
        }}
        className="border p-2 rounded-lg mr-4"
      >
        <option value="en">English</option>
        <option value="af">Afrikaans</option>
        <option value="zu">isiZulu</option>
        <option value="st">Sesotho</option>
        <option value="nso">Sepedi</option>
        <option value="tn">Setswana</option>
        <option value="ts">Xitsonga</option>
        <option value="ss">siSwati</option>
        <option value="nr">isiNdebele</option>
        <option value="xh">isiXhosa</option>
        <option value="ve">Tshivenḓa</option>
        <option value="pt">Portuguese</option>
        <option value="fr">French</option>
      </select>
    </div>
  );
};

export default Navbar;
